var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.tag ? _vm.tag : "div",
    {
      tag: "component",
      staticClass:
        "text-20 md:text-28 font-medium max-w-md leading-tight text-fg"
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }